import * as React from 'react';
import theme from './theme.module.scss';
import {Icon, Badge} from "@vidazoo/ui-kit";
import PanelHeader from "./components/panel-header/PanelHeader";
import PanelBody from "./components/panel-body/PanelBody";
import useUserNotificationsManager from "../../hooks/useUserNotificationsManager";
import {observer} from "mobx-react";
import {useMainMenuContext} from "../../../app/components/main-menu/contexts/MainMenuContext";

const GROUP = 'USER_NOTIFICATION';

function NotificationPanel(): React.JSX.Element {
    const manager = useUserNotificationsManager();
    const {selectedGroup, setSelectedGroup} = useMainMenuContext();

    return (
        <div onMouseEnter={() => setSelectedGroup(GROUP)} onMouseLeave={() => setSelectedGroup(null)}
             className={theme.notificationPanel}
             onKeyDown={event => {if (event.key === 'Escape') setSelectedGroup(null);}}>
            <button className={theme.icon} type="button" aria-label="Notifications" aria-expanded={selectedGroup === GROUP}
                    onClick={() => setSelectedGroup(GROUP)}>
                <Badge red className={theme.badge}>{manager.unseenCount}</Badge>
                <Icon className="text-white" iconName="icon-publishers" iconColor="white" size={2.5}/>
            </button>
            {selectedGroup === GROUP ? (
                <div className={theme.drawer} role="region" aria-label="Notifications">
                    <PanelHeader/>
                    <PanelBody/>
                </div>
            ) : null}
        </div>
    );
}

export default observer(NotificationPanel);
